/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AllowedCompanyMappingService {

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppAllowedCompanyMapping(
formData?: {
SourceCompanyId?: string;
DestinationCompanyId?: string;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/allowed-company-mapping',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static putApiIdentityApiAppAllowedCompanyMapping(
id: string,
formData?: {
SourceCompanyId?: string;
DestinationCompanyId?: string;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/app/allowed-company-mapping/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiAppAllowedCompanyMapping(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/app/allowed-company-mapping/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
